const isEnabled = widgetSettings =>
  widgetSettings && Object.values(widgetSettings).some(setting => setting.active);

export default isEnabled;
export { isEnabled };
